import { createSlice } from "@reduxjs/toolkit";
import {
  login,
  logout,
  registerBrand,
  registerCreator,
  socialLogin,
  verifyOtp,
} from "./authService";

// Initial state
const initialState = {
  user: null,
  loading: false,
  error: null,
  isOtpSent: false,
  isAuthenticated: false,
};

// Auth slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.isOtpSent = false;
      localStorage.removeItem("token");
    },
    updateUser: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    // Register Creator
    builder
      .addCase(registerCreator.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerCreator.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpSent = true;
      })
      .addCase(registerCreator.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Register Brand
      .addCase(registerBrand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerBrand.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpSent = true;
      })
      .addCase(registerBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Login
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.isAuthenticated = true;

        // Check if OTP verification is required
        if (action.payload.message?.includes("verification code")) {
          state.isOtpSent = true;
          state.isAuthenticated = false;
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpSent = false;
        state.isAuthenticated = true;
        state.user = action.payload.data;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Social Login
      .addCase(socialLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(socialLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.isAuthenticated = true;
      })
      .addCase(socialLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Logout
      .addCase(logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.isAuthenticated = false;
      })
      .addCase(logout.rejected, (state) => {
        state.loading = false;
        state.user = null;
        state.isAuthenticated = false;
      });
  },
});

export const { clearErrors, clearAuth, updateUser } = authSlice.actions;
export default authSlice.reducer;
